import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { searchFormConfig } from './config/search.config'
import { contentTableConfig } from './config/content.config'
import { usePageSearch } from '@/hooks/userPageSearch'
import { getListData } from '@/service/main/system'
import { useStore } from '@/store'
import dayjs from 'dayjs'
import {initEmptyParam} from "@/hooks/useInitParam";
import localCache from '@/utils/cache'


export default /*#__PURE__*/_defineComponent({
  __name: 'LowFrequencyLiveEmp',
  setup(__props) {

initEmptyParam()
const store = useStore()
const userInfo = store.state.login.userInfo

const getEmp = async () => {
  let userList = localCache.getCache('empData')
  const userOptions = userList.map((item: any) => {
    return {title: item.realName, value: item.realName};
  })
  const userItem = searchFormConfig.formItems.find((item) => item.field === 'empName')
  userItem!.options = userOptions;
}
getEmp()

const queryParam = {
  empName: userInfo.realName,
  dayRange: 30,
  maxWatchDays: 7
}
store.commit('system/changeQueyryInfo', queryParam)
const resetCb = () => {
  return queryParam
}
//定义筛选规则
const filterRules = [
  '筛选规则：',
  '1、根据直播链接后缀匹配',
  '2、客户归属 —— 必须是本人明下的客户',
  '3、默认查询30天内观看直播天数小于7天的用户',
]
const [
  pageContentRef,
  handleResetClick,
  handleSearchClick,
  handleDownBtnClick
] = usePageSearch(resetCb)

return (_ctx: any,_cache: any) => {
  const _component_PageSearch = _resolveComponent("PageSearch")!
  const _component_PageContent = _resolveComponent("PageContent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_PageSearch, {
      searchFormConfig: _unref(searchFormConfig),
      onResetBtnClick: _unref(handleResetClick),
      onSearchBtnClick: _unref(handleSearchClick)
    }, null, 8, ["searchFormConfig", "onResetBtnClick", "onSearchBtnClick"]),
    _createVNode(_component_PageContent, {
      ref_key: "pageContentRef",
      ref: pageContentRef,
      contentTableConfig: _unref(contentTableConfig),
      pageName: "lowFrequencyLiveEmp",
      pageUrl: "/main/lowFrequencyLiveEmp/queryByCondition",
      downUrl: "/main/lowFrequencyLiveEmp/download",
      filterRules: filterRules,
      downFilename: "低频访问客户信息.xlsx",
      onDownBtnClick: _unref(handleDownBtnClick)
    }, null, 8, ["contentTableConfig", "onDownBtnClick"])
  ]))
}
}

})